import React from "react";

export default function QuestionMainSection({ children }) {
  return <div className="col-lg-8 col-md-12">{children}</div>;
}
